/**
 * <GainChip> — ce qu'un effort rapporte : « +25 XP », « +10 pétales » (molecule).
 *
 * La chip de gain du livre (chap. 16). Une enveloppe mince de `<Badge>` : elle écrit le gain d'une
 * seule façon (`formatGain`) et choisit sa face une fois pour tout le jeu, la variante
 * `role-student` en TINTE (rose pâle en clair, prune sur la nuit, encre à 6,1 et 6,8:1) : pleine,
 * elle se lisait comme un bouton. Corail à gagner comme gagné : c'est la coche ou la barre verte à
 * côté qui dit l'acquis, pas la chip.
 *
 * En tête, le glyphe plein de ce qui se gagne (`<GameGlyph>`), à l'encre de la chip : le pétale ou
 * l'éclair se voit avant le nombre.
 */
import React from "react"

import { Badge } from "../../atoms/Badge"
import { badgeFace } from "../../atoms/Badge/badgeFace"
import { formatGain, type GameUnit } from "../../utils/gameAmount"
import { GAME_GLYPH_SIZE, GameGlyph } from "../GameGlyph"

export type GainChipProps = {
    /** Le gain, toujours positif. */
    amount: number
    /** `xp` (défaut) ou `petals`. */
    unit?: GameUnit
    testID?: string
}

/** La face de la chip de gain : la seule du jeu. */
const VARIANT = "role-student"

export function GainChip(props: GainChipProps) {
    const { amount, unit = "xp", testID } = props

    const leading = (
        <GameGlyph name={unit} size={GAME_GLYPH_SIZE.chip} plate={false} color={badgeFace(VARIANT, true).ink} />
    )

    return <Badge testID={testID} text={formatGain(amount, unit)} variant={VARIANT} tinted leading={leading} />
}
